import { LoyaltyCurrency } from '@rd/types';
import {
  LoyaltyCurrencyActions,
  LoyaltyCurrencyActionTypes,
} from '../actions/loyalty-currency.actions';

export interface LoyaltyCurrencyState {
  selected: LoyaltyCurrency | null;
}

const initialState: LoyaltyCurrencyState = {
  selected: null,
};

export function loyaltyCurrencyReducer(
  state: LoyaltyCurrencyState = initialState,
  action: LoyaltyCurrencyActions,
): LoyaltyCurrencyState {
  switch (action.type) {
    case LoyaltyCurrencyActionTypes.CHANGE_LOYALTY_CURRENCY:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
}
